module.exports = __webpack_public_path__ + "media/images/arrow-trend-up-71d2da1a19024514f8d10594c53039f6.svg";